import { useQuery } from '@tanstack/react-query';

import { getCheckupByPartyId } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import type { CheckupItem } from '../../types';

import queryKeys from './../queryKeys';

export default function useCheckup(
  partyId: string,
  options?: QueryOptions<CheckupItem[]>,
) {
  return useQuery({
    queryKey: queryKeys.checkup(partyId),
    queryFn: async () => {
      const result = await getCheckupByPartyId(
        {
          path: { party_id: partyId },
        },
        wgApi,
      );

      return result.items as CheckupItem[];
    },
    ...options,
  });
}
